import { gaTracking, getCurrentPageLocation } from "../../lib/ga";

/**
 * Tracks quiz start event
 * @param title - Title of the quiz
 * @see /GAExamples/quiz_start.js
 */
export const quizStartTracker = (title: string): void => {
  gaTracking({
    event: "quiz_start",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      title,
    },
  });
};

/**
 * Tracks quiz completion/submit event
 * @param title - Title of the quiz
 * @see /GAExamples/quiz_submit.js
 */
export const quizEndTracker = (title: string): void => {
  gaTracking({
    event: "quiz_submit",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      title,
    },
  });
};
